import React, { useState, useEffect, useCallback, useMemo, useRef, Children } from 'react';
import {EuiFlexGroup, EuiButton, EuiSpacer, EuiFlexItem, EuiFormRow, EuiPanel, EuiFieldNumber, EuiSwitch, EuiButtonIcon, EuiIcon, EuiLoadingSpinner, EuiFilterGroup, EuiFilterButton} from '@elastic/eui';
import moment from 'moment';
import { SelectorInformesContainer as SelectorInformes } from '../../../../components/Selectores/Informes/container';
import { SelectorPeriodosContainer as SelectorPeriodos} from '../../../../components/Selectores/Periodos/container';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoAñoPeriodo/container';
import { SelectorEjercicioContainer as SelectorEjercicio} from '../../../../components/Selectores/Ejercicio/container';
import { SelectorVehiculosContainer as SelectorVehiculos} from '../../../../components/Selectores/VehiculosMultiple/container';

// import './styles.css';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';


interface dataRequest {año:number, periodo:number, IdTipoInforme: string, IdTipo: string, Vehiculos: any}

interface Props {
  onExport(data: dataRequest): void;
  data: any;
  isLoading: boolean;
}

const toDataUrl = async(file:any,callback?:any) =>{
  var xhr = new XMLHttpRequest();
     xhr.responseType = 'blob';
     xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
     callback(reader.result);
  }
    reader.readAsDataURL(xhr.response);
 };
  xhr.open('GET', file);
  xhr.send();
  }

export const SeleccionInformesScreen = (props: Props) => {

  let { onExport, data, isLoading } = props;
  const ref:any = useRef();
  
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  const _tiposMoneda = [{label:'Moneda Corriente',value:'MCR'}, {label:'Moneda Constante',value:'MCT'}]

  let [año, setAño] = useState<number>(_año);
  let [periodo, setPeriodo] = useState<any>(undefined);
  let [informe, setInforme] = useState<any>(undefined);
  let [tipocontenido, setTipoContenido] = useState<any>(undefined);
  let [vehiculos, setVehiculos] = useState<any>([]);

  let logo:any = undefined;

  const onChangePeriodo = (value:any) => {
    setPeriodo(value)
  }

  const onInformeChange = (value: any) => {
    setInforme(value);
  }

  const onVehiculosChange = (value: any) => {
    setVehiculos([...value])
  }

  const onTipoContenidoChange = (value: any) => {
    setTipoContenido(value);
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      año : año, periodo: periodo, IdTipoInforme: informe, IdTipo: tipocontenido, Vehiculos: vehiculos.map((x: any) => x.value).join(',')
    }
    return (
      reqdata
    )
  }

  const getFilter = useMemo(()=> {return{'año':año, 'periodo':periodo, 'idTipoContenido':informe}},[año,periodo,informe])

  const onExportar = () =>{
    onExport(getRequesData());
  }
  

  const Actions: Action[] = useMemo(()=>[
    {handle:onExportar,text:"Exportar",size:"s", isDisabled: isLoading}
  ],[onExportar, data])

  return (
    <>
      <EuiFlexGroup gutterSize='none' style={{height:'100%'}} className="collapsePanel">
        <EuiFlexItem grow={false}>
          <EuiFlexGroup direction='column' style={{height:'100%'}} justifyContent="flexStart">
              <EuiFlexItem grow={false}>
                <SelectorEjercicio value={año} onChange={(e:any) => setAño(e)} />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <SelectorPeriodos fullWidth valueOfSelected={periodo} onChange={(value: any) => onChangePeriodo(value)} soloCerrados={true} año={año} />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <SelectorTiposContenido valueOfSelected={tipocontenido} onChange={onTipoContenidoChange} año={año} periodo={periodo} />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <SelectorInformes compressed valueOfSelected={informe} onChange={onInformeChange} informesExcel={true} />
              </EuiFlexItem>
              {(informe || '') === 'EXVEH' && 
              <EuiFlexItem grow={false}>
                <SelectorVehiculos selectedOptions={vehiculos} onChange={onVehiculosChange} singleSelection={false}  /*isDisabled={(informe || '') !== 'EXVEH'}*//>
              </EuiFlexItem>
              } 
          </EuiFlexGroup>
        </EuiFlexItem>  
        <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
          <EuiFlexGroup alignItems='baseline'>
            <EuiFlexItem>
            <EuiFlexGroup alignItems='center' >
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem>
                <Menu actions={Actions}/>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
          <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
              <EuiFlexItem grow={false} style={{marginBottom:'0', alignItems: 'center'}}>
                {isLoading && <EuiLoadingSpinner size="xl" />}
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
    </>
  );
};

export default SeleccionInformesScreen;
